export default {
  getCategoryList: '/gateway/capp/mallcenter/GoodsSaleForAppRpcService/getCategoryList',
  queryZoneSalesList: '/gateway/capp/mallcenter/GoodsSaleForAppRpcService/queryZoneSalesList',
  querySaleList: '/gateway/capp/mallcenter/GoodsSaleForAppRpcService/querySaleList',
  getPath: '/v3/smartbox/tokenCreate',
  regionList: '/v3/mallcenter/home/region/list',
  activityList: '/v3/mallcenter/home/activity/list',
  getActivityData: '/v3/ad/trans/cdsp/request'
}
